import { ThemeModule } from '../../front/lib/ThemeModule';
import { initContactForm7 } from '../../front/cf7';
import { createGenericModal } from '../../front/components';
export class ContactForm extends ThemeModule {
    init() {
        const openBtnEl = this.querySelector('.openBtn');
        const getContactFormDOM = ContactForm.createLazyContactFormDOMFn(this.getElementById('modalContent'));
        openBtnEl.addEventListener('click', () => {
            const modal = createGenericModal({
                bodyDOM: getContactFormDOM(),
            });
            modal.show();
        });
    }
    /**
     * Creates a function that would make a contact form element from base64 encoded HTML content
     * and initialize Contact Form 7 once.
     * This is to prevent bots from scraping the contact form HTML.
     *
     * @param {HTMLScriptElement} scriptEl Script element with base64 encoded HTML content
     */
    static createLazyContactFormDOMFn(scriptEl) {
        let contactFormEl = null;
        return () => {
            if (contactFormEl) {
                return contactFormEl;
            }
            const content = atob(scriptEl.textContent || '');
            contactFormEl = document.createElement('div');
            contactFormEl.innerHTML = content;
            initContactForm7(contactFormEl);
            return contactFormEl;
        };
    }
}
